<template>
  <div class="container">
    <div class="main-header"></div>
    <div class="header-empty-line"></div>
    <template v-for="(item) in block_list">
      <block-video v-if="item.title=='best-videos'"
                   :key="item.title"
                   :block-data="item"></block-video>
    </template>
    <template v-for="(item) in block_list">
      <block v-if="item.title!='best-videos'"
             :key="item.title"
             :block-data="item"></block>
    </template>
    <right-nav></right-nav>
  </div>
</template>

<script>

import BlockVideo from '../components/Block-Video.vue'
import Block from '../components/Block.vue'
import RightNav from '../components/Right-Nav.vue'
import block_list from '@/assets/data'

export default {
  components: {
    BlockVideo,
    Block,
    RightNav
  },
  data () {
    return {
      block_list
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background: url(../../../assets/images/pc/header-bg.png) no-repeat center
      270px,
    url(../../../assets/images/pc/leaf.png) no-repeat left bottom;
  background-size: 100% auto, 571px auto;
  padding-bottom: 88px;
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
}
.main-header {
  height: 260px;
  background: url(../../../assets/images/pc/header.png) no-repeat center center;
  background-size: auto 100%;
}
.header-empty-line {
  height: 10px;
  background-color: #45767a;
}
</style>
